import { render } from "./Breadcrumbs.vue?vue&type=template&id=46e126d0"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "46e126d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46e126d0', script)) {
    api.reload('46e126d0', script)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=46e126d0", () => {
    api.rerender('46e126d0', render)
  })

}

script.__file = "src/components/Breadcrumbs.vue"

export default script